import { render, staticRenderFns } from "./DiscountNewCredentialsCardFlow.vue?vue&type=template&id=21d8d5c4&scoped=true&"
import script from "./DiscountNewCredentialsCardFlow.vue?vue&type=script&lang=js&"
export * from "./DiscountNewCredentialsCardFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8d5c4",
  null
  
)

export default component.exports